// @flow strict

import * as React from 'react';

import makeClassNameComponent, {
  type ClassNameComponent,
} from 'src/utils/makeClassNameComponent';

import css from './popover.css';


type Props = {
  label: string,
  sublabel?: React.Node,
  TagName?: string,
  children: React.Node,
};

export function FormPair({
  label,
  sublabel,
  TagName = 'label',
  children,
}: Props): React.Node {
  return (
    <TagName className={css.formPair}>
      <div className={css.formPairTitle}>
        <span className={css.formLabel}>{label}</span>
        <span className={css.formSublabel}>{sublabel}</span>
      </div>
      {children}
    </TagName>
  );
}

export function SmallFormPair({label, children}: Props): React.Node {
  return (
    <label className={css.formPair}>
      <span className={css.formLabelSmall}>{label}</span>
      {children}
    </label>
  );
}

export function FormGroup({
  label,
  children,
  tooltip,
}: {
  ...Props,
  tooltip?: React.Node,
}): React.Node {
  return (
    <div className={css.formGroup}>
      {tooltip ? (
        <div className={css.labelRow}>
          <span className={css.formLabel}>{label}</span>
          {tooltip}
        </div>
      ) : (
        <span className={css.formLabel}>{label}</span>
      )}
      <div className={css.formGroupContent}>{children}</div>
    </div>
  );
}

export const ButtonsSmall: ClassNameComponent<> = makeClassNameComponent(
  css.buttonsSmall,
);
export const ButtonsLarge: ClassNameComponent<> = makeClassNameComponent(
  css.buttonsLarge,
);
